// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IkNOO","badges":"styles_badges__J1N46"};